import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dAssignment from "../Restaumatic.PromotionsEngine.Tools.Assignment/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dPromotionEvaluation from "../Restaumatic.PromotionsEngine.Tools.PromotionEvaluation/index.js";
const updatePromotionalItem = promotionalItems => promotionalItem => Data$dFunctor.arrayMap(item => {
  if (item.promotionalItemId === promotionalItem.promotionalItemId) { return promotionalItem; }
  return item;
})(promotionalItems);
const updateMaybePromotionalItem = promotionalItems => x => {
  if (x.tag === "Just") {
    const $0 = x._1;
    return Data$dFunctor.arrayMap(item => {
      if (item.promotionalItemId === $0.promotionalItemId) { return $0; }
      return item;
    })(promotionalItems);
  }
  return promotionalItems;
};
const oldenUserSelections = /* #__PURE__ */ Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.oldenUserSelection);
const nonEnableableProductItemKey = itemCand => item => {
  if (!Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWith(itemCand.promotion)(item.promotion)) {
    return Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.allocatedProductItemKeys(item);
  }
  return [];
};
const filterEnabledByUserItems = /* #__PURE__ */ Data$dArray.filter(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.isEnabledByUser);
const maybeEnableCartPromotionalItem = dictOrd => promotionalItems => promotionalItem => {
  if (
    Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWithAllOthers(promotionalItem.promotion)(Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.promotion)(filterEnabledByUserItems(promotionalItems)))
  ) {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        ...Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.setAssignment(dictOrd)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.AssignmentToCart)(promotionalItem),
        selection: Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$SelectionStatus("UserEnabled", 0)
      }
    );
  }
  return Data$dMaybe.Nothing;
};
const maybeEnableProductPromotionalItem = dictOrd => promotionalItems => promotionalItem => chooseFrom => {
  const $0 = chooseFrom((() => {
    const $0 = dictOrd.Eq0();
    return Data$dFoldable.foldrArray(Data$dArray.delete({eq: x => y => $0.eq(x.product)(y.product) && x.productSeq === y.productSeq}))(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr)((() => {
      if (promotionalItem.target.tag === "TargetCart") { return Data$dMap$dInternal.Leaf; }
      if (promotionalItem.target.tag === "TargetProductItems") { return promotionalItem.target._1; }
      $runtime.fail();
    })()))(Control$dBind.arrayBind(filterEnabledByUserItems(promotionalItems))(nonEnableableProductItemKey(promotionalItem)));
  })());
  if ($0.tag === "Just") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        ...Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.setAssignment(dictOrd)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$PromotionalItemAssignment(
          "AssignmentToProduct",
          $0._1
        ))(promotionalItem),
        selection: Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$SelectionStatus("UserEnabled", 0)
      }
    );
  }
  return Data$dMaybe.Nothing;
};
const disablePromotionalItem = dictOrd => promotionalItems => promotionalItem => {
  const $0 = {
    ...Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.unassign(dictOrd)(promotionalItem),
    selection: Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.UserDisabled
  };
  return Data$dFunctor.arrayMap(item => {
    if (item.promotionalItemId === $0.promotionalItemId) { return $0; }
    return item;
  })(promotionalItems);
};
const disablePromotionalItemAndEvaluate = dictOrd => inputCartData => promotionalItems => promotionalItem => Restaumatic$dPromotionsEngine$dTools$dPromotionEvaluation.evaluateEnabledPromotionalItems(dictOrd.Eq0())(inputCartData)(disablePromotionalItem(dictOrd)(promotionalItems)(promotionalItem));
const disablePromotionalItemAndRecalculate = dictOrd => inputCartData => promotionalItems => promotionalItem => Restaumatic$dPromotionsEngine$dTools$dAssignment.assignPromotionalItems(dictOrd)(inputCartData)(disablePromotionalItem(dictOrd)(promotionalItems)(promotionalItem));
const compareUserSelectionAge = a => b => Data$dMaybe.ordMaybe(Data$dOrd.ordInt).compare(a.selection.tag === "UserEnabled"
  ? Data$dMaybe.$Maybe("Just", a.selection._1)
  : Data$dMaybe.Nothing)(b.selection.tag === "UserEnabled" ? Data$dMaybe.$Maybe("Just", b.selection._1) : Data$dMaybe.Nothing);
const disableOldest = promoFilter => assignmentMode => promoItems => updateMaybePromotionalItem(promoItems)((() => {
  const $0 = (() => {
    if (assignmentMode.tag === "AutoAssign") { return true; }
    if (assignmentMode.tag === "ManualAssign") { return false; }
    $runtime.fail();
  })()
    ? Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.AutoDisabled
    : Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.UserDisabled;
  const $1 = Data$dFoldable.maximumBy(Data$dFoldable.foldableArray)(compareUserSelectionAge)(Data$dArray.filter(promoFilter)(filterEnabledByUserItems(promoItems)));
  if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", {...$1._1, selection: $0}); }
  return Data$dMaybe.Nothing;
})());
const disableOldestAnyItem = /* #__PURE__ */ disableOldest(v => true);
const enableCartPromotionalItem = enableCartPromotionalItem$a0$copy => enableCartPromotionalItem$a1$copy => enableCartPromotionalItem$a2$copy => enableCartPromotionalItem$a3$copy => {
  let enableCartPromotionalItem$a0 = enableCartPromotionalItem$a0$copy;
  let enableCartPromotionalItem$a1 = enableCartPromotionalItem$a1$copy;
  let enableCartPromotionalItem$a2 = enableCartPromotionalItem$a2$copy;
  let enableCartPromotionalItem$a3 = enableCartPromotionalItem$a3$copy;
  let enableCartPromotionalItem$c = true;
  let enableCartPromotionalItem$r;
  while (enableCartPromotionalItem$c) {
    const dictOrd = enableCartPromotionalItem$a0;
    const assignmentMode = enableCartPromotionalItem$a1;
    const promotionalItems = enableCartPromotionalItem$a2;
    const promotionalItem = enableCartPromotionalItem$a3;
    if (
      Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWithAllOthers(promotionalItem.promotion)(Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.promotion)(filterEnabledByUserItems(promotionalItems)))
    ) {
      const $0 = {
        ...Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.setAssignment(dictOrd)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.AssignmentToCart)(promotionalItem),
        selection: Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$SelectionStatus("UserEnabled", 0)
      };
      enableCartPromotionalItem$c = false;
      enableCartPromotionalItem$r = Data$dFunctor.arrayMap(item => {
        if (item.promotionalItemId === $0.promotionalItemId) { return $0; }
        return item;
      })(promotionalItems);
      continue;
    }
    enableCartPromotionalItem$a0 = dictOrd;
    enableCartPromotionalItem$a1 = assignmentMode;
    enableCartPromotionalItem$a2 = disableOldest(v => true)(assignmentMode)(promotionalItems);
    enableCartPromotionalItem$a3 = promotionalItem;
  }
  return enableCartPromotionalItem$r;
};
const enableProductPromotionalItem = enableProductPromotionalItem$a0$copy => enableProductPromotionalItem$a1$copy => enableProductPromotionalItem$a2$copy => enableProductPromotionalItem$a3$copy => enableProductPromotionalItem$a4$copy => {
  let enableProductPromotionalItem$a0 = enableProductPromotionalItem$a0$copy;
  let enableProductPromotionalItem$a1 = enableProductPromotionalItem$a1$copy;
  let enableProductPromotionalItem$a2 = enableProductPromotionalItem$a2$copy;
  let enableProductPromotionalItem$a3 = enableProductPromotionalItem$a3$copy;
  let enableProductPromotionalItem$a4 = enableProductPromotionalItem$a4$copy;
  let enableProductPromotionalItem$c = true;
  let enableProductPromotionalItem$r;
  while (enableProductPromotionalItem$c) {
    const dictOrd = enableProductPromotionalItem$a0;
    const assignmentMode = enableProductPromotionalItem$a1;
    const promotionalItems = enableProductPromotionalItem$a2;
    const promotionalItem = enableProductPromotionalItem$a3;
    const chooseFrom = enableProductPromotionalItem$a4;
    const enabledByUserItems = filterEnabledByUserItems(promotionalItems);
    if (
      Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWithAll(promotionalItem.promotion)(Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.promotion)(Data$dArray.filter(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.isCartPromotionalItem)(enabledByUserItems)))
    ) {
      const disallowedProductItemKeys = Control$dBind.arrayBind(enabledByUserItems)(nonEnableableProductItemKey(promotionalItem));
      const sourceItemsFree = Data$dFoldable.foldrArray(v => v1 => false)(true)((() => {
        const $0 = dictOrd.Eq0();
        return Data$dArray.intersectBy(x => y => $0.eq(x.product)(y.product) && x.productSeq === y.productSeq)((() => {
          if (promotionalItem.source.tag === "NoSource") { return []; }
          if (promotionalItem.source.tag === "SourceProductItems") { return promotionalItem.source._1; }
          $runtime.fail();
        })())(disallowedProductItemKeys);
      })());
      const candidateProductItemKeys = Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr)((() => {
        if (promotionalItem.target.tag === "TargetCart") { return Data$dMap$dInternal.Leaf; }
        if (promotionalItem.target.tag === "TargetProductItems") { return promotionalItem.target._1; }
        $runtime.fail();
      })());
      const v = chooseFrom((() => {
        const $0 = dictOrd.Eq0();
        return Data$dFoldable.foldrArray(Data$dArray.delete({eq: x => y => $0.eq(x.product)(y.product) && x.productSeq === y.productSeq}))(candidateProductItemKeys)(disallowedProductItemKeys);
      })());
      const $0 = () => {
        if (Data$dFoldable.foldrArray(v$1 => v1 => false)(true)(candidateProductItemKeys)) {
          enableProductPromotionalItem$c = false;
          enableProductPromotionalItem$r = promotionalItems;
          return;
        }
        enableProductPromotionalItem$a0 = dictOrd;
        enableProductPromotionalItem$a1 = assignmentMode;
        enableProductPromotionalItem$a2 = disableOldest(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.isProductPromotionalItem)(assignmentMode)(promotionalItems);
        enableProductPromotionalItem$a3 = promotionalItem;
        enableProductPromotionalItem$a4 = chooseFrom;
      };
      if (v.tag === "Just") {
        if (sourceItemsFree) {
          const $1 = {
            ...Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.setAssignment(dictOrd)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$PromotionalItemAssignment(
              "AssignmentToProduct",
              v._1
            ))(promotionalItem),
            selection: Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$SelectionStatus("UserEnabled", 0)
          };
          enableProductPromotionalItem$c = false;
          enableProductPromotionalItem$r = Data$dFunctor.arrayMap(item => {
            if (item.promotionalItemId === $1.promotionalItemId) { return $1; }
            return item;
          })(promotionalItems);
          continue;
        }
        $0();
        continue;
      }
      $0();
      continue;
    }
    enableProductPromotionalItem$a0 = dictOrd;
    enableProductPromotionalItem$a1 = assignmentMode;
    enableProductPromotionalItem$a2 = disableOldest(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.isCartPromotionalItem)(assignmentMode)(promotionalItems);
    enableProductPromotionalItem$a3 = promotionalItem;
    enableProductPromotionalItem$a4 = chooseFrom;
  }
  return enableProductPromotionalItem$r;
};
const enablePromotionalItem = dictOrd => assignmentMode => promotionalItems => promotionalItem => {
  if (promotionalItem.promotion.conditions.tag === "CartPromotion") { return enableCartPromotionalItem(dictOrd)(assignmentMode)(promotionalItems)(promotionalItem); }
  if (promotionalItem.promotion.conditions.tag === "ProductPromotion") {
    return enableProductPromotionalItem(dictOrd)(assignmentMode)(promotionalItems)(promotionalItem)(Data$dArray.head);
  }
  $runtime.fail();
};
const enablePromotionalItemAndRecalculate = dictOrd => inputCartData => promotionalItems => promotionalItem => {
  if (promotionalItem.selection.tag === "UserEnabled") { return promotionalItems; }
  return Restaumatic$dPromotionsEngine$dTools$dAssignment.assignPromotionalItems(dictOrd)(inputCartData)(enablePromotionalItem(dictOrd)(inputCartData.assignmentMode)(oldenUserSelections(promotionalItems))(promotionalItem));
};
const maybeEnablePromotionalItem$p = dictOrd => promotionalItems => promotionalItem => {
  if (promotionalItem.promotion.conditions.tag === "CartPromotion") { return maybeEnableCartPromotionalItem(dictOrd)(promotionalItems)(promotionalItem); }
  if (promotionalItem.promotion.conditions.tag === "ProductPromotion") { return maybeEnableProductPromotionalItem(dictOrd)(promotionalItems)(promotionalItem)(Data$dArray.head); }
  $runtime.fail();
};
const maybeEnablePromotionalItem = dictOrd => promotionalItems => promotionalItem => {
  const $0 = updatePromotionalItem(oldenUserSelections(promotionalItems));
  const $1 = maybeEnablePromotionalItem$p(dictOrd)(promotionalItems)(promotionalItem);
  if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0($1._1)); }
  return Data$dMaybe.Nothing;
};
const maybeEnablePromotionalItemAndRecalculate = dictOrd => inputCartData => promotionalItems => promotionalItem => {
  const $0 = maybeEnablePromotionalItem(dictOrd)(promotionalItems)(promotionalItem);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Restaumatic$dPromotionsEngine$dTools$dAssignment.assignPromotionalItems(dictOrd)(inputCartData)($0._1)); }
  return Data$dMaybe.Nothing;
};
const chooseAssignmentProductItemKey = dictEq => assignment => availableProductItemKeys => {
  if (assignment.tag === "AssignmentToProduct") {
    const $0 = assignment._1;
    return Data$dFoldable.find(Data$dFoldable.foldableArray)(v => dictEq.eq(v.product)($0.product) && v.productSeq === $0.productSeq)(Data$dArray.fromFoldableImpl(Data$dFoldable.foldrArray)(availableProductItemKeys));
  }
  return Data$dMaybe.Nothing;
};
const maybeEnableAssignPromotionalItem = dictOrd => promotionalItems => promotionalItem => assignment => {
  if (promotionalItem.promotion.conditions.tag === "CartPromotion") {
    const enabledItemMb = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItemAssignment(dictOrd.Eq0()).eq(assignment)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.AssignmentToCart)
      ? maybeEnableCartPromotionalItem(dictOrd)(promotionalItems)(promotionalItem)
      : Data$dMaybe.Nothing;
    const $0 = updatePromotionalItem(oldenUserSelections(promotionalItems));
    if (enabledItemMb.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0(enabledItemMb._1)); }
    return Data$dMaybe.Nothing;
  }
  if (promotionalItem.promotion.conditions.tag === "ProductPromotion") {
    const enabledItemMb = maybeEnableProductPromotionalItem(dictOrd)(promotionalItems)(promotionalItem)(chooseAssignmentProductItemKey(dictOrd.Eq0())(assignment));
    const $0 = updatePromotionalItem(oldenUserSelections(promotionalItems));
    if (enabledItemMb.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0(enabledItemMb._1)); }
    return Data$dMaybe.Nothing;
  }
  $runtime.fail();
};
const maybeEnableAssignPromotionalItemAndRecalculate = dictOrd => inputCartData => promotionalItems => promotionalItem => assignment => {
  const $0 = maybeEnableAssignPromotionalItem(dictOrd)(promotionalItems)(promotionalItem)(assignment);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Restaumatic$dPromotionsEngine$dTools$dAssignment.assignPromotionalItems(dictOrd)(inputCartData)($0._1)); }
  return Data$dMaybe.Nothing;
};
const changePromotionalItem = dictEq => promotionalItems => promotionalItem => input => {
  const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.changeInput(dictEq)(promotionalItem)(input);
  return Data$dFunctor.arrayMap(item => {
    if (item.promotionalItemId === $0.promotionalItemId) { return $0; }
    return item;
  })(promotionalItems);
};
export {
  changePromotionalItem,
  chooseAssignmentProductItemKey,
  compareUserSelectionAge,
  disableOldest,
  disableOldestAnyItem,
  disablePromotionalItem,
  disablePromotionalItemAndEvaluate,
  disablePromotionalItemAndRecalculate,
  enableCartPromotionalItem,
  enableProductPromotionalItem,
  enablePromotionalItem,
  enablePromotionalItemAndRecalculate,
  filterEnabledByUserItems,
  maybeEnableAssignPromotionalItem,
  maybeEnableAssignPromotionalItemAndRecalculate,
  maybeEnableCartPromotionalItem,
  maybeEnableProductPromotionalItem,
  maybeEnablePromotionalItem,
  maybeEnablePromotionalItem$p,
  maybeEnablePromotionalItemAndRecalculate,
  nonEnableableProductItemKey,
  oldenUserSelections,
  updateMaybePromotionalItem,
  updatePromotionalItem
};
